import React from 'react';
import { DiscountRequestNotification, NotificationType } from 'interfaces';
import { Text } from 'view/atoms';
import { formatDateTime, decodeHtmlString, formatTextWithUrls } from 'utils';
import { useTranslation } from 'react-i18next';
import * as S from './NotificationCard.styles';
import {
  getNotificationCardDescription,
  getNotificationCardTitle,
} from './utils/utils';

type Props = {
  notification: DiscountRequestNotification;
};

const bold700 = {
  mobile: { fontWeight: 700, fontSize: '16px' },
  desktop: { fontWeight: 700 },
};

const bold600 = {
  mobile: { fontWeight: 600 },
  desktop: { fontWeight: 600 },
};

export const NotificationCard = ({ notification }: Props) => {
  const { t } = useTranslation();

  return (
    <S.NotificationCard>
      <Text
        kind='h4'
        customStyles={!notification.received ? bold700 : undefined}
      >
        {getNotificationCardTitle(t, notification)}
      </Text>

      <Text
        kind='body'
        customStyles={!notification.received ? bold600 : undefined}
      >
        {decodeHtmlString(getNotificationCardDescription(t, notification))}
      </Text>

      {notification.notificationType === NotificationType.STATUS_CHANGED &&
        notification.hrComment && (
          <Text
            kind='body'
            customStyles={!notification.received ? bold600 : undefined}
          >
            {formatTextWithUrls(
              decodeHtmlString(
                t('serviceNotifications.discountRequest.hrComment', {
                  comment: notification.hrComment,
                }),
              ) ?? '',
              { asLink: true },
            )}
          </Text>
        )}

      <Text kind='small1' color='gray2'>
        {formatDateTime(notification.notificationTime)}
      </Text>

      {!notification.received && (
        <S.NotificationBubble aria-label='Notification bubble' />
      )}
    </S.NotificationCard>
  );
};
